@let presentUploadDataDialog = presentUploadDataDialogSg();
@let connectors =
  connectorsEc.plugins.currentListPlugin.feature.selectors.entities.asSignal();

<atn-ds-page>
  <atn-ds-page-header
    name="Data Catalog"
    pageHeader
  >
    <div
      class="actions"
      actions
    >
      @if (connectors.length > 0) {
        <atn-ds-button
          type="white"
          [disabled]="false"
          (click)="openIntegrationLauncher()"
          data-test-id="runIntegrationsButton"
        >
          <i class="atn-icon atn-run atn-blue"></i>
          Run integrations
        </atn-ds-button>
      }
      <atn-ds-button
        [isIcon]="true"
        type="white"
        [disabled]="false"
        (click)="toggleIsUploadDataDialogDisplayed()"
        data-test-id="uploadButton"
      >
        <i class="atn-icon atn-upload atn-blue"></i>
      </atn-ds-button>
      <atn-ds-button
        [isIcon]="true"
        type="white"
        [disabled]="false"
        (click)="downloadClickHandler()"
        data-test-id="downloadButton"
      >
        <i class="atn-icon atn-download atn-blue"></i>
      </atn-ds-button>
    </div>
  </atn-ds-page-header>
  <atn-ds-floating-horizontal-tabs>
    <ng-template
      atnDsTab
      name="Dimensions"
    >
      <atn-ds-table [config]="dimensionsTableConfig" />
    </ng-template>

    <ng-template
      atnDsTab
      name="Entities"
    >
      <atn-ds-table [config]="entitiesTableConfig" />
    </ng-template>

    <ng-template
      atnDsTab
      name="Snapshots"
    >
      <atn-ds-table [config]="snapshotsTableConfig" />
    </ng-template>

    <ng-template
      atnDsTab
      name="Enums"
    >
      <atn-ds-table [config]="enumsTableConfig" />
    </ng-template>
  </atn-ds-floating-horizontal-tabs>
</atn-ds-page>

@if (presentUploadDataDialog) {
  <atn-ds-centered-overlay>
    <atn-upload-data-dialog
      (cancel)="toggleIsUploadDataDialogDisplayed()"
      (uploadFinish)="toggleIsUploadDataDialogDisplayed()"
    />
  </atn-ds-centered-overlay>
}

<atn-integration-run-dialog />
